import React from "react";
import "./Css/Gallary.css";
import img1 from "./Images/palour5.jpg";
import img2 from "./Images/palour1.jpg";
import img3 from "./Images/palour2.jpg";
import img4 from "./Images/palour3.jpg";


export default function Palour() {
  return (
    <section className="school-social-section">
        
      <h2 className="school-social-title">महिलांसाठी कौशल्य प्रशिक्षण त्यामध्ये फॅशन डिझायनिंग,ज्वेलरी मेकिंग, ब्युटीपार्लर. इत्यादी प्रशिक्षण
</h2>

      <div className="school-social-grid">

        {/* Left Big Image */}
        <img src={img1} alt="event" className="school-img big-img" />

        {/* Right Image Grid */}
        <div className="right-grid">

          {/* Row 1 - Two Small Images */}
          <div className="top-small-row">
            <img src={img2} alt="event" className="school-img small-img" />
            <img src={img3} alt="event" className="school-img small-img" />
          </div>

          {/* Middle Wide Image */}
          <div className="middle-wide-row">
            <img src={img4} alt="event" className="school-img wide-img" />
            
          </div>
        </div>
      </div>

    </section>
  );
}
